import type * as starterLazyIndex from "./starterLazyIndex";
import { LazyModule, LazyImport } from "owa-bundling";

// Legacy Create rule must not load the starter implementation.
const starterLazyModule: LazyModule<typeof starterLazyIndex> = new LazyModule(() => import(/* webpackChunkName: "InboxRuleStarters" */ "./starterLazyIndex"), { name: "InboxRuleStarters" });

export const lazyOpenInboxRulesSettings: LazyImport<typeof starterLazyIndex.openInboxRulesSettings, typeof starterLazyModule> = new LazyImport(starterLazyModule, m => m.openInboxRulesSettings);

export const lazyPrepareInboxRuleStarterContext: LazyImport<typeof starterLazyIndex.prepareInboxRuleStarterContext, typeof starterLazyModule> = new LazyImport(starterLazyModule, m => m.prepareInboxRuleStarterContext);

export const lazyOpenInboxRuleStarter: LazyImport<typeof starterLazyIndex.openInboxRuleStarter, typeof starterLazyModule> = new LazyImport(starterLazyModule, m => m.openInboxRuleStarter);

export const lazySaveInboxRuleStarter: LazyImport<typeof starterLazyIndex.saveInboxRuleStarter, typeof starterLazyModule> = new LazyImport(starterLazyModule, m => m.saveInboxRuleStarter);
